<div
  (click)="onClick()"
  class="header-bar-button"
  [ngClass]="[theme, isSelectedClass, isDisabledClass, isSmallClass]"
  fxLayout="row"
  fxLayoutAlign="center center">
  <div
    class="mr-2"
    [ngClass]="[theme, isSelectedClass]">
    <i
      class="icon"
      [ngClass]="[icon, isSelectedClass]"></i>
  </div>
  <div
    class="label"
    [ngClass]="[theme, isSelectedClass]">
    {{ label }}
  </div>
</div>
